var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Printing")]),_c('PrintingYN',{model:{value:(_vm.form.printing),callback:function ($$v) {_vm.$set(_vm.form, "printing", $$v)},expression:"form.printing"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }